import { useEffect, useRef, useState } from 'react';
import { UseViewPortProps } from './interfaces';

export default function useViewPort(params?: UseViewPortProps) {
	const [position, setPosition] = useState<'INTERSECTING' | 'ABOVE' | 'BELLOW'>();
	const [isVisible, setIsVisible] = useState(false);

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				const [{ isIntersecting }] = entries;

				if (isIntersecting) {
					setPosition('INTERSECTING');
				}

				if (!isIntersecting && ref.current) {
					setPosition(ref.current.getBoundingClientRect().top > 0 ? 'BELLOW' : 'ABOVE');
				}

				if (!params?.once) {
					setIsVisible(isIntersecting);
					return;
				}

				if (isIntersecting) {
					setIsVisible(true);
					observer.disconnect();
				}
			},
			{
				root: null,
				rootMargin: '0px',
			},
		);

		if (ref.current) observer.observe(ref.current);

		return () => observer.disconnect();
	}, []);

	return {
		ref,
		position,
		isInViewPort: isVisible,
	};
}
